/**
 * How an organization's name and code are compared.
 *
 * Kept in their own file, apart from the rest of the organization rules, for one
 * practical reason: the import script that seeds WVCEA's member list has to normalise
 * names exactly the way the application does, and it runs under plain Node. Node can
 * strip types but not the parameter properties every error class here uses, so a module
 * holding an error class cannot be imported by a script. These two functions hold
 * nothing but text handling, so both sides can share them and neither has to keep its
 * own copy.
 *
 * That matters more than it sounds. If a script normalised names even slightly
 * differently, seeding the list would create a second set of schools beside the ones
 * already recorded, which is the exact failure this normalisation exists to prevent.
 */

/**
 * Names are compared with case, spacing and punctuation set aside, because the same
 * school arrives as "Grace Christian School", "grace christian school" and
 * "Grace Christian  School." from three different documents.
 */
export function normalizeOrganizationName(value: string): string {
  return value
    .normalize("NFKD")
    .replace(/\p{Diacritic}/gu, "")
    .toLocaleLowerCase("en-US")
    .replace(/[^\p{L}\p{N}]+/gu, " ")
    .trim();
}

/** Codes are compared without case or surrounding space. Nothing else is assumed. */
export function normalizeOrganizationCode(value: string): string {
  return value.trim().toLocaleUpperCase("en-US");
}
